import { Core } from "@faire/design-tokens";
import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useMyOrdersPrefetch } from "@faire/retailer-visitor-shared/views/orders/useMyOrdersPrefetch";
import { Button } from "@faire/web--source/slate/Button";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackRetailersOrdersInGlobalNavClick } from "@faire/web-api--source/events/retailers/click/ordersInGlobalNav";
import { trackRetailersOrdersInGlobalNavHover } from "@faire/web-api--source/events/retailers/hover/ordersInGlobalNav";
import orders from "@faire/web-api--source/routes/www/orders";
import React, { useRef } from "react";
import styled from "styled-components";

export const HeaderOrdersLink = () => {
  const { isDesktopAndAbove } = useViewport();
  const { retailer } = useRetailer();
  const prefetchMyOrders = useMyOrdersPrefetch();
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  const handleClick = () => {
    buttonRef.current?.blur();
    trackRetailersOrdersInGlobalNavClick();
  };

  const handleFocus = () => {
    trackRetailersOrdersInGlobalNavHover();
    prefetchMyOrders();
  };

  if (retailer === undefined) {
    return null;
  }
  if (!isDesktopAndAbove) {
    return null;
  }

  return (
    <StyledButton
      buttonRef={buttonRef}
      variant="tertiary"
      linkTo={orders()}
      onClick={handleClick}
      onMouseEnter={handleFocus}
      onFocus={handleFocus}
    >
      <StrictLocalMsg defaultMessage="Orders" />
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
    position: relative;
      padding: ${getSpacing(10, "2x")};
      border-radius: ${getSpacing("4x")};
      text-decoration: none;
      &:hover,
      &:focus {
        text-decoration: none;
        background-color: ${Core.surface.subdued};
        border-radius: ${getSpacing("4x")};
      }
    }
  `;
